export const boltPatternSuggestions = [
  { label: "4/98", adType: "rim", numberOfBolts: "4", boltCircle: "98", type: "rim-boltpattern" },
  { label: "4/100", adType: "rim", numberOfBolts: "4", boltCircle: "100", type: "rim-boltpattern" },
  { label: "4/108", adType: "rim", numberOfBolts: "4", boltCircle: "108", type: "rim-boltpattern" },
  { label: "5/100", adType: "rim", numberOfBolts: "5", boltCircle: "100", type: "rim-boltpattern" },
  { label: "5/105", adType: "rim", numberOfBolts: "5", boltCircle: "105", type: "rim-boltpattern" },
  { label: "5/108", adType: "rim", numberOfBolts: "5", boltCircle: "108", type: "rim-boltpattern" },
  { label: "5/110", adType: "rim", numberOfBolts: "5", boltCircle: "110", type: "rim-boltpattern" },
  { label: "5/112", adType: "rim", numberOfBolts: "5", boltCircle: "112", type: "rim-boltpattern" },
  { label: "5/114.3", adType: "rim", numberOfBolts: "5", boltCircle: "114.3", type: "rim-boltpattern" },
  { label: "5/115", adType: "rim", numberOfBolts: "5", boltCircle: "115", type: "rim-boltpattern" },
  { label: "5/118", adType: "rim", numberOfBolts: "5", boltCircle: "118", type: "rim-boltpattern" },
  { label: "5/120", adType: "rim", numberOfBolts: "5", boltCircle: "120", type: "rim-boltpattern" },
  { label: "5/130", adType: "rim", numberOfBolts: "5", boltCircle: "130", type: "rim-boltpattern" },
  { label: "5/139.7", adType: "rim", numberOfBolts: "5", boltCircle: "139.7", type: "rim-boltpattern" },
  { label: "6/114.3", adType: "rim", numberOfBolts: "6", boltCircle: "114.3", type: "rim-boltpattern" },
  { label: "6/130", adType: "rim", numberOfBolts: "6", boltCircle: "130", type: "rim-boltpattern" },
  { label: "6/139.7", adType: "rim", numberOfBolts: "6", boltCircle: "139.7", type: "rim-boltpattern" },
];

export const rimDiameterSuggestions = [
  { label: "13 tum", adType: "rim", diameter: "13", type: "rim-diameter" },
  { label: "14 tum", adType: "rim", diameter: "14", type: "rim-diameter" },
  { label: "15 tum", adType: "rim", diameter: "15", type: "rim-diameter" },
  { label: "16 tum", adType: "rim", diameter: "16", type: "rim-diameter" },
  { label: "17 tum", adType: "rim", diameter: "17", type: "rim-diameter" },
  { label: "18 tum", adType: "rim", diameter: "18", type: "rim-diameter" },
  { label: "19 tum", adType: "rim", diameter: "19", type: "rim-diameter" },
  { label: "20 tum", adType: "rim", diameter: "20", type: "rim-diameter" },
  { label: "21 tum", adType: "rim", diameter: "21", type: "rim-diameter" },
  { label: "22 tum", adType: "rim", diameter: "22", type: "rim-diameter" },
  { label: "23 tum", adType: "rim", diameter: "23", type: "rim-diameter" },
  { label: "24 tum", adType: "rim", diameter: "24", type: "rim-diameter" },
];

export const rimBrandSuggestions = [
  { label: "Aiways", adType: "rim", categoryLevel1: "aiways", type: "rim-brand" },
  { label: "Alfa Romeo", adType: "rim", categoryLevel1: "alfaromeo", type: "rim-brand" },
  { label: "Aston Martin", adType: "rim", categoryLevel1: "astonmartin", type: "rim-brand" },
  { label: "Audi", adType: "rim", categoryLevel1: "audi", type: "rim-brand" },
  { label: "Bentley", adType: "rim", categoryLevel1: "bentley", type: "rim-brand" },
  { label: "BMW", adType: "rim", categoryLevel1: "bmw", type: "rim-brand" },
  { label: "BYD", adType: "rim", categoryLevel1: "byd", type: "rim-brand" },
  { label: "Cadillac", adType: "rim", categoryLevel1: "cadillac", type: "rim-brand" },
  { label: "Chevrolet", adType: "rim", categoryLevel1: "chevrolet", type: "rim-brand" },
  { label: "Citroen", adType: "rim", categoryLevel1: "citroen", type: "rim-brand" },
  { label: "Cupra", adType: "rim", categoryLevel1: "cupra", type: "rim-brand" },
  { label: "Dacia", adType: "rim", categoryLevel1: "dacia", type: "rim-brand" },
  { label: "Dodge", adType: "rim", categoryLevel1: "dodge", type: "rim-brand" },
  { label: "Ferrari", adType: "rim", categoryLevel1: "ferrari", type: "rim-brand" },
  { label: "Fiat", adType: "rim", categoryLevel1: "fiat", type: "rim-brand" },
  { label: "Ford", adType: "rim", categoryLevel1: "ford", type: "rim-brand" },
  { label: "Honda", adType: "rim", categoryLevel1: "honda", type: "rim-brand" },
  { label: "Hyundai", adType: "rim", categoryLevel1: "Hyundai", type: "rim-brand" },
  { label: "Ineos", adType: "rim", categoryLevel1: "ineos", type: "rim-brand" },
  { label: "Isuzu", adType: "rim", categoryLevel1: "isuzu", type: "rim-brand" },
  { label: "Iveco", adType: "rim", categoryLevel1: "iveco", type: "rim-brand" },
  { label: "Jaguar", adType: "rim", categoryLevel1: "jaguar", type: "rim-brand" },
  { label: "Jeep", adType: "rim", categoryLevel1: "jeep", type: "rim-brand" },
  { label: "Kia", adType: "rim", categoryLevel1: "kia", type: "rim-brand" },
  { label: "Lamborghini", adType: "rim", categoryLevel1: "lamborghini", type: "rim-brand" },
  { label: "Land Rover", adType: "rim", categoryLevel1: "landrover", type: "rim-brand" },
  { label: "Lexus", adType: "rim", categoryLevel1: "lexus", type: "rim-brand" },
  { label: "Lotus", adType: "rim", categoryLevel1: "lotus", type: "rim-brand" },
  { label: "Lynk & Co", adType: "rim", categoryLevel1: "lynkoco", type: "rim-brand" },
  { label: "Maserati", adType: "rim", categoryLevel1: "maserati", type: "rim-brand" },
  { label: "Maxus", adType: "rim", categoryLevel1: "maxus", type: "rim-brand" },
  { label: "Mazda", adType: "rim", categoryLevel1: "mazda", type: "rim-brand" },
  { label: "McLaren", adType: "rim", categoryLevel1: "mclaren", type: "rim-brand" },
  { label: "Mercedes-Benz", adType: "rim", categoryLevel1: "mercedes-benz", type: "rim-brand" },
  { label: "MG", adType: "rim", categoryLevel1: "mg", type: "rim-brand" },
  { label: "Mini", adType: "rim", categoryLevel1: "mini", type: "rim-brand" },
  { label: "Mitsubishi", adType: "rim", categoryLevel1: "mitsubishi", type: "rim-brand" },
  { label: "Mopedbil", adType: "rim", categoryLevel1: "mopedbil", type: "rim-brand" },
  { label: "NIO", adType: "rim", categoryLevel1: "nio", type: "rim-brand" },
  { label: "Nissan", adType: "rim", categoryLevel1: "nissan", type: "rim-brand" },
  { label: "Opel", adType: "rim", categoryLevel1: "opel", type: "rim-brand" },
  { label: "ORA", adType: "rim", categoryLevel1: "ora", type: "rim-brand" },
  { label: "Peugeot", adType: "rim", categoryLevel1: "peugeot", type: "rim-brand" },
  { label: "Polestar", adType: "rim", categoryLevel1: "polestar", type: "rim-brand" },
  { label: "Porsche", adType: "rim", categoryLevel1: "porsche", type: "rim-brand" },
  { label: "Renault", adType: "rim", categoryLevel1: "renault", type: "rim-brand" },
  { label: "Rolls-Royce", adType: "rim", categoryLevel1: "rolls-royce", type: "rim-brand" },
  { label: "Saab", adType: "rim", categoryLevel1: "saab", type: "rim-brand" },
  { label: "Seat", adType: "rim", categoryLevel1: "seat", type: "rim-brand" },
  { label: "Skoda", adType: "rim", categoryLevel1: "skoda", type: "rim-brand" },
  { label: "Smart", adType: "rim", categoryLevel1: "smart", type: "rim-brand" },
  { label: "Subaru", adType: "rim", categoryLevel1: "subaru", type: "rim-brand" },
  { label: "Suzuki", adType: "rim", categoryLevel1: "suzuki", type: "rim-brand" },
  { label: "Tesla", adType: "rim", categoryLevel1: "tesla", type: "rim-brand" },
  { label: "Toyota", adType: "rim", categoryLevel1: "toyota", type: "rim-brand" },
  { label: "Volkswagen", adType: "rim", categoryLevel1: "volkswagen", type: "rim-brand" },
  { label: "Volvo", adType: "rim", categoryLevel1: "volvo", type: "rim-brand" },
  { label: "Xpeng", adType: "rim", categoryLevel1: "xpeng", type: "rim-brand" },
  { label: "Zeekr", adType: "rim", categoryLevel1: "zeekr", type: "rim-brand" },
];

export const falgarSuggestions = [
  ...boltPatternSuggestions,
  ...rimDiameterSuggestions,
  ...rimBrandSuggestions,
];
